import { render, staticRenderFns } from "./DisplayErrorV2.vue?vue&type=template&id=7b958aef&"
import script from "./DisplayErrorV2.vue?vue&type=script&lang=js&"
export * from "./DisplayErrorV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports